import { useEffect } from 'react';

// Capture browser navigation before React Router receives popstate. Restore the
// existing quiz entry instead of creating guard entries or discarding router state.
export function installQuizHistoryGuard(onBlocked, canLeave) {
  const entry = window.history.state;
  const url = window.location.href;
  let restoring = false;
  const listener = event => {
    if (canLeave()) return;
    event.stopImmediatePropagation();
    if (restoring) { restoring = false; onBlocked(); return; }
    const delta = Number.isInteger(entry?.idx) && Number.isInteger(event.state?.idx) ? entry.idx - event.state.idx : 0;
    if (delta) { restoring = true; window.history.go(delta); }
    else { window.history.replaceState(entry, '', url); onBlocked(); }
  };
  window.addEventListener('popstate', listener, true);
  return () => window.removeEventListener('popstate', listener, true);
}

export function useQuizBrowserBack(target) {
  useEffect(() => {
    const index = window.history.state?.idx;
    let redirecting = false;
    const listener = event => {
      const destination = event.state?.idx;
      if (Number.isInteger(target?.historyIndex) && destination === target.historyIndex && window.location.pathname === target.pathname) {
        // Filters, page and selected mode may have changed locally since this
        // entry was created. Restore its snapshot before Router reads it.
        window.history.replaceState({ ...window.history.state, usr: target.state }, '', window.location.href);
      }
      if (redirecting) { redirecting = false; return; }
      // Skip mode/instruction entries after pause or submission, without
      // rewriting history or intercepting Forward navigation.
      if (Number.isInteger(index) && Number.isInteger(destination) && Number.isInteger(target?.historyIndex) &&
          destination < index && destination > target.historyIndex) {
        event.stopImmediatePropagation();
        redirecting = true;
        window.history.go(target.historyIndex - destination);
      }
    };
    window.addEventListener('popstate', listener, true);
    return () => window.removeEventListener('popstate', listener, true);
  }, [target]);
}

